import { useAuth } from 'contexts/auth';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { Loading } from 'shell/components';

const FederatedLoginPage = () => {
    const { auth } = useAuth();
    const history = useHistory();
    const pathname = window.location.pathname;
    if (pathname === 'forgot-password') return history.push('/forgot-password');
    if (auth) return history.push('/');
    return <Loading />;
};

export default FederatedLoginPage;
